module.exports = __webpack_public_path__ + "static/img/vip-img4.217fd57.png";


//////////////////
// WEBPACK FOOTER
// ./static/moblieHome/vip-img4.png
// module id = sPgj
// module chunks = 1